import React from 'react';

import LogoImg from '../../../assets/images/original.png';

const Logo = (props) => {
    return (
        <div style={{
            backgroundColor:'white',
            padding:'8px',
            boxSizing:'border-box',
            borderRadius:'5px'}} className={props.logo}>
            <img src={LogoImg} alt="img" width="40px" height="30px" style={props.value}/>
        </div>
    );
}

export default Logo;